import React from 'react';
import { Panel } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';

const CategorySidebar = ({ categories, subCategories, expandedCategoryId, handleExpandGroup, handleCategoryClick }) => (
  <Panel id="category-nav" className="panelStyle">
    <Panel className="panelStyle" >
      <div style={{ fontWeight: 'bold', cursor: 'pointer' }} name="group" id="g-1" onClick={() => {handleCategoryClick('All');}}>
        <Translate value="all" />
      </div>
    </Panel>
    {
      categories &&
      categories.map((category) => {
        let groupNum = parseInt(category.GroupNum);
        if (groupNum < 10) groupNum = `0${groupNum}`;
        const id = category.ProductGroup_id;
        let description = 'Misc';
        if (localStorage.getItem('lang') === 'ch') {
          description = 'Description';
        } else if (localStorage.getItem('lang') === 'en') {
          description = 'Name';
        }
        return (
          <Panel className="panelStyle" >
            <div
              style={{ fontFamily: 'Arial Black', cursor: 'pointer' }}
              name="group"
              id={`g${id}`}
              onClick={() => { handleExpandGroup(id); handleCategoryClick(category[description], id); } }
            >
              <label style={{ fontWeight: 'bold' }}>{groupNum}</label>{' '}<Translate value={category[description]} />
            </div>
            {
              expandedCategoryId === id && subCategories &&
                <div>
                  {
                    subCategories.map(category => (
                      <li
                        className="clickListLi"
                        style={{ fontFamily: 'Arial', cursor: 'pointer' }}
                        name="category" id={`c${category.ProductCategory_id}`}
                        onClick={() => {handleCategoryClick(category.Description, null, category.ProductCategory_id);}}
                      >
                        <label style={{ fontWeight: 'bold' }}>{category.CategoryNum}</label>{` ${category.Description}`}
                      </li>
                    ))
                  }
                </div>
            }
          </Panel>
        );
      })
    }
  </Panel>
);

export default CategorySidebar;



// WEBPACK FOOTER //
// ./master/jsx/components/General/CategoryAnalysis/components/CategorySidebar.jsx